import script from "./4G15M.vue?vue&type=script&setup=true&lang=js"
export * from "./4G15M.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__